export default function IconNetworkArrow({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_1290_95)">
        <path
          d="M0.375 9C0.375 10.1327 0.598092 11.2542 1.03154 12.3006C1.46499 13.3471 2.1003 14.2979 2.9012 15.0988C3.70211 15.8997 4.65292 16.535 5.69936 16.9685C6.74579 17.4019 7.86735 17.625 9 17.625C10.1327 17.625 11.2542 17.4019 12.3006 16.9685C13.3471 16.535 14.2979 15.8997 15.0988 15.0988C15.8997 14.2979 16.535 13.3471 16.9685 12.3006C17.4019 11.2542 17.625 10.1327 17.625 9C17.625 7.86735 17.4019 6.74579 16.9685 5.69936C16.535 4.65292 15.8997 3.70211 15.0988 2.9012C14.2979 2.1003 13.3471 1.46499 12.3006 1.03154C11.2542 0.598092 10.1327 0.375 9 0.375C7.86735 0.375 6.74579 0.598092 5.69936 1.03154C4.65292 1.46499 3.70211 2.1003 2.9012 2.9012C2.1003 3.70211 1.46499 4.65292 1.03154 5.69936C0.598092 6.74579 0.375 7.86735 0.375 9Z"
          fill="#93C5FD"
        />
        <path
          d="M2.97185 11.2514C2.97161 9.74501 3.36593 8.26478 4.11557 6.95811C4.8652 5.65143 5.94399 4.56389 7.24457 3.80372C8.54514 3.04355 10.0221 2.63728 11.5285 2.62535C13.0349 2.61341 14.5181 2.99623 15.8306 3.73569C15.0501 2.72337 14.0544 1.89718 12.9154 1.3169C11.7765 0.736618 10.5228 0.41675 9.24503 0.380435C7.96729 0.34412 6.69745 0.592266 5.52738 1.10692C4.3573 1.62158 3.31625 2.38988 2.47953 3.35624C1.64281 4.3226 1.03135 5.46285 0.689382 6.69452C0.347411 7.92619 0.283482 9.21847 0.502219 10.4779C0.720956 11.7373 1.21689 12.9323 1.95414 13.9765C2.6914 15.0208 3.65154 15.8881 4.7651 16.5157C3.59982 15.0085 2.96896 13.1566 2.97185 11.2514Z"
          fill="#EFF6FF"
        />
        <path
          d="M1.42188 13.126H7.12337"
          stroke="#1D4ED8"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.88281 4.12598H16.1208"
          stroke="#1D4ED8"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.37456 8.62598H0.382812"
          stroke="#1D4ED8"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.45159 0.395508C3.95159 5.27051 4.03334 11.614 8.53334 17.614"
          stroke="#1D4ED8"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.54688 0.395508C11.2276 2.14491 12.3434 4.35928 12.7494 6.75101"
          stroke="#1D4ED8"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.625 9.00098C17.625 7.29512 17.1192 5.62756 16.1714 4.20919C15.2237 2.79081 13.8767 1.68533 12.3006 1.03252C10.7246 0.379714 8.99044 0.20891 7.31735 0.541707C5.64426 0.874505 4.10744 1.69596 2.90121 2.90218C1.69498 4.10841 0.873528 5.64524 0.540731 7.31833C0.207933 8.99141 0.378737 10.7256 1.03154 12.3016C1.68435 13.8776 2.78984 15.2247 4.20821 16.1724C5.62658 17.1201 7.29414 17.626 9 17.626"
          stroke="#1D4ED8"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9721 12.3065L16.6154 10.6625C16.6615 10.6162 16.6947 10.5588 16.7118 10.4958C16.7289 10.4327 16.7292 10.3664 16.7128 10.3032C16.6964 10.24 16.6637 10.1822 16.6181 10.1355C16.5725 10.0888 16.5154 10.0548 16.4526 10.037L8.27763 7.70745C8.21346 7.68935 8.14563 7.68867 8.08112 7.7055C8.01661 7.72233 7.95776 7.75605 7.91062 7.80319C7.86347 7.85034 7.82975 7.90919 7.81292 7.9737C7.7961 8.03821 7.79677 8.10604 7.81488 8.1702L10.1399 16.3452C10.1577 16.4081 10.1917 16.4653 10.2384 16.5111C10.2852 16.5568 10.3431 16.5895 10.4064 16.606C10.4697 16.6225 10.5362 16.6221 10.5993 16.6049C10.6624 16.5877 10.7199 16.5543 10.7661 16.508L12.3036 14.9712L14.6901 17.357C14.7604 17.4273 14.8558 17.4667 14.9553 17.4667C15.0547 17.4667 15.1501 17.4273 15.2204 17.357L17.3586 15.2255C17.4289 15.1551 17.4684 15.0598 17.4684 14.9603C17.4684 14.8609 17.4289 14.7655 17.3586 14.6952L14.9721 12.3065Z"
          fill="#93C5FD"
        />
        <path
          d="M16.2907 16.292L17.3587 15.2255C17.429 15.1552 17.4685 15.0599 17.4685 14.9604C17.4685 14.861 17.429 14.7656 17.3587 14.6953L14.9729 12.3088L16.6162 10.6648C16.6623 10.6186 16.6955 10.5611 16.7126 10.4981C16.7297 10.4351 16.73 10.3687 16.7136 10.3055C16.6971 10.2423 16.6645 10.1845 16.6189 10.1378C16.5732 10.0911 16.5162 10.0572 16.4534 10.0393L8.27841 7.70979C8.21411 7.69139 8.14606 7.69051 8.08131 7.70726C8.01656 7.72401 7.95747 7.75777 7.91016 7.80504L16.2907 16.292Z"
          fill="#EFF6FF"
        />
        <path
          d="M14.9721 12.3065L16.6154 10.6625C16.6615 10.6162 16.6947 10.5588 16.7118 10.4958C16.7289 10.4327 16.7293 10.3664 16.7128 10.3032C16.6964 10.24 16.6637 10.1822 16.6181 10.1355C16.5725 10.0888 16.5154 10.0548 16.4526 10.037L8.27763 7.70745C8.21346 7.68935 8.14563 7.68867 8.08112 7.7055C8.01661 7.72233 7.95776 7.75605 7.91062 7.80319C7.86347 7.85034 7.82975 7.90919 7.81292 7.9737C7.7961 8.03821 7.79677 8.10604 7.81488 8.1702L10.1399 16.3452C10.1577 16.4081 10.1917 16.4653 10.2384 16.5111C10.2852 16.5568 10.3431 16.5895 10.4064 16.606C10.4697 16.6225 10.5362 16.6221 10.5993 16.6049C10.6624 16.5877 10.7199 16.5543 10.7661 16.508L12.3036 14.9712L14.6901 17.357C14.7604 17.4273 14.8558 17.4667 14.9553 17.4667C15.0547 17.4667 15.1501 17.4273 15.2204 17.357L17.3586 15.2255C17.4289 15.1551 17.4684 15.0598 17.4684 14.9603C17.4684 14.8609 17.4289 14.7655 17.3586 14.6952L14.9721 12.3065Z"
          stroke="#1D4ED8"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1290_95">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
